import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import clsx from 'clsx';
const SplitContentBySlash = (props) => {
    const { content, classNames, showLeadingAndTrailingLineBreaks, style } = props;
    if (typeof content !== 'string' || !content.trim())
        return null;
    const cleaned = content.replace(/<\/?p>/g, '');
    const leadingSlashesMatch = /^\/+/.exec(cleaned);
    const leadingSlashes = leadingSlashesMatch ? leadingSlashesMatch[0].length : 0;
    const trailingSlashesMatch = /\/{1,100}$/.exec(cleaned);
    const trailingSlashes = trailingSlashesMatch ? trailingSlashesMatch[0].length : 0;
    let trimmed = cleaned;
    trimmed = trimmed.replace(/^\/{1,100}/, '');
    trimmed = trimmed.replace(/\/{1,100}$/, '');
    const mainParts = trimmed.split('/');
    const createBreaks = (count, prefix) => Array.from({ length: count }, (_, i) => _jsx("br", {}, `${prefix}-${i}`));
    return (_jsx(_Fragment, { children: (() => {
            return [
                ...(showLeadingAndTrailingLineBreaks ? createBreaks(leadingSlashes, 'leading') : []),
                ...mainParts.map((line, i) => (_jsx(Box, { className: clsx(classNames === null || classNames === void 0 ? void 0 : classNames.headingLine, classNames === null || classNames === void 0 ? void 0 : classNames.headingColor), component: "span", style: style, children: line.trim() }, `${line.trim()}-${i}`))),
                ...(showLeadingAndTrailingLineBreaks ? createBreaks(trailingSlashes, 'trailing') : []),
            ];
        })() }));
};
export default SplitContentBySlash;
